<template>
    <BaseModal
        :id="'static-schedule'"
        :title="title"
        :size="''"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <div class="row mb-0 assignments">
                <div class="col-12" style="margin-top:30px;">
                    <div class="row mb-0">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col" v-for="(item, i) in week_table_headers" :key="i" v-html="item.name"/>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="'sun'" type="checkbox" class="custom-control-input" v-model="week_form_data.sunday"/>
                                                <label :for="'sun'" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="'mon'" type="checkbox" class="custom-control-input" v-model="week_form_data.monday"/>
                                                <label :for="'mon'" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="'tue'" type="checkbox" class="custom-control-input" v-model="week_form_data.tuesday"/>
                                                <label :for="'tue'" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="'wed'" type="checkbox" class="custom-control-input" v-model="week_form_data.wednesday"/>
                                                <label :for="'wed'" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="'thur'" type="checkbox" class="custom-control-input" v-model="week_form_data.thursday"/>
                                                <label :for="'thur'" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="'fri'" type="checkbox" class="custom-control-input" v-model="week_form_data.friday"/>
                                                <label :for="'fri'" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="'sat'" type="checkbox" class="custom-control-input" v-model="week_form_data.saturday"/>
                                                <label :for="'sat'" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal__buttons text-center text-md-right" style="margin-top:30px;">
                        <button 
                            type="button"
                            class="modal__buttons__item cancel"
                            data-dismiss="modal"
                            aria-label="Close"
                            v-html="'Cancel'"
                        />

                        <button class="modal__buttons__item" @click="saveNewSchedule()">
                            Save <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </BaseModal>
</template>

<script>

import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'

export default {

    name: 'ScheduleModal',

    props: [
        'title',
        'breadcrumb',
        'week_table_headers',
        'week_form_data',
    ],

    components: {
        BaseModal,
        Breadcrumb,
    },

    methods: {

        saveNewSchedule()
        {
            this.$emit('saveNewSchedule', this.week_form_data)
        },

        cancel()
        {
            window.$('#static-schedule').modal('hide')
        },

    }

}

</script>